import apiService from './apiService';

export const getOrders = (page = 1, size = 25, filters = {}) => {
  const params = new URLSearchParams({ page, size });
  const { closed, origin_name, search } = filters;
  // closed: 'active' | 'closed' | '' -> backend bool
  if (closed === 'closed') params.set('closed', 'true');
  if (closed === 'active') params.set('closed', 'false');
  if (origin_name) params.set('origin_name', origin_name);
  if (search && search.trim()) params.set('search', search.trim());
  return apiService.get(`/orders?${params.toString()}`);
};

export const getOrderDetail = (id) =>
  apiService.get(`/orders/${id}`);
